<div class="indicator-container">
  <div class="value-percent" [ngClass]="[colorClass]">{{ value }}%</div>
  <mat-progress-bar
    mode="determinate"
    [ngClass]="['capacity-bar', colorClass]"
    [value]="value"
  ></mat-progress-bar>
</div>
